// extracted by mini-css-extract-plugin
export var announcementContainer = "container-module--announcementContainer--1c325";
export var landingPageContainer = "container-module--landingPageContainer--80ee5";
export var megaMenuContainer = "container-module--megaMenuContainer--323af";
export var root = "container-module--root--bdba9";
export var rootFooter = "container-module--rootFooter--ffc54";